export const ProgressRail = ({ slides, active, onGo }) => (
  <nav className="progress-rail" aria-label="Slides" data-testid="progress-rail">
    {slides.map((s, i) => (
      <button
        key={s.id}
        type="button"
        className="rail-item"
        data-active={i === active ? "true" : "false"}
        onClick={() => onGo(i)}
        aria-label={`Slide ${i + 1} — ${s.label}`}
        aria-current={i === active ? "step" : undefined}
        data-testid={`rail-item-${s.id}`}
      >
        <span className="rail-num">{String(i + 1).padStart(2, "0")}</span>
        <span className="rail-tick" aria-hidden="true" />
        <span className="rail-label">{s.label}</span>
      </button>
    ))}
  </nav>
);

export default ProgressRail;
